import { DateTime, Duration } from 'luxon';
import { BehaviorSubject } from 'rxjs';

function minutesToMs(minutes: number): number {
  const _SECONDS_IN_MINUTE = 60;
  const _MS_IN_SECOND = 1000;

  return minutes * _SECONDS_IN_MINUTE * _MS_IN_SECOND;
}

/** Countdown timer with ability to defer start of countdown */
export class DeferredTimer {
  private readonly onTimeout: () => void;
  private readonly minutesBeforeCountdown: number;
  private readonly countdownDurationMinutes: number;

  private beforeCountdownTimerId: number | null = null;
  private countdownIntervalId: number | null = null;

  private endTime: DateTime | null = null;

  remainingTime: BehaviorSubject<Duration | null> = new BehaviorSubject<Duration | null>(null);

  constructor(onTimeout: () => void, minutesBeforeCountdown: number, countdownDurationMinutes: number) {
    this.minutesBeforeCountdown = minutesBeforeCountdown;
    this.countdownDurationMinutes = countdownDurationMinutes;
    this.onTimeout = onTimeout;
  }

  private reset() {
    if (this.beforeCountdownTimerId !== null) {
      clearTimeout(this.beforeCountdownTimerId);
      this.beforeCountdownTimerId = null;
    }

    if (this.countdownIntervalId !== null) {
      clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = null;
    }
  }

  start() {
    this.endTime = null;
    this.remainingTime.next(null);

    this.beforeCountdownTimerId = window.setTimeout(() => {
      this.endTime = DateTime.now().plus({ minutes: this.countdownDurationMinutes });
      this.remainingTime.next(this.endTime.diffNow());
      this.countdownIntervalId = window.setInterval(() => {
        if (!this.endTime) {
          this.abort();
          return;
        }

        this.remainingTime.next(this.endTime.diffNow());

        if (this.endTime < DateTime.now()) {
          this.onTimeout();
          this.abort();
        }
      }, 1000);
    }, minutesToMs(this.minutesBeforeCountdown));
  }

  restart() {
    this.reset();
    this.start();
  }

  abort() {
    this.reset();
    this.endTime = null;
    this.remainingTime.next(null);
  }
}
